import compose from 'recompose/compose';

import optionCallback from "../optionCallback";

import Inner1 from './Inner1';
import Inner2 from './Inner2';
import Inner3 from './Inner3';
import Inner4 from './Inner4';
import Inner5 from './Inner5';
import Inner6 from './Inner6';
import Inner7 from './Inner7';
import Inner8 from './Inner8';
import Inner9 from './Inner9';
import Inner10 from './Inner10';
import Inner11 from './Inner11';
import Inner12 from './Inner12';
import Inner13 from './Inner13';
import Inner14 from './Inner14';
import Inner15 from './Inner15';
import Inner16 from './Inner16';
import Inner17 from './Inner17';
import Inner18 from './Inner18';
import Inner19 from './Inner19';
import Inner20 from './Inner20';
import Inner21 from './Inner21';
import Inner22 from './Inner22';
import Inner23 from './Inner23';
import Inner24 from './Inner24';
import Inner25 from './Inner25';
import Inner26 from './Inner26';
import Inner27 from './Inner27';
import Inner28 from './Inner28';
import Inner29 from './Inner29';
import {eyeColor, rotate} from "../../nodevn/ultil";
import React from "react";


function render({ source, transform, ...options}: any){
	let { color, data, transform : trans, size }: any = source || {};
	const attr = eyeColor({...options, color });
	size = size || 40;
	const $pos  = (100 - size) / 2;
	const $scale = (size / 100);
	const $g_attr = { transform : ($pos || $scale) ? `translate(${$pos}, ${$pos}) scale(${$scale})` : "", };
	return rotate(<g {...$g_attr}>{data}</g>, trans, transform, attr)
}


export default compose(
	optionCallback('inner', 'inner0', Inner1, { render, size: 50}),
	optionCallback('inner', 'inner1', Inner2, { render}),
	optionCallback('inner', 'inner2', Inner3, { render, size: 50}),
	optionCallback('inner', 'inner3', Inner4, { render, size: 50}),
	optionCallback('inner', 'inner4', Inner5, { render, size: 50}),
	optionCallback('inner', 'inner5', Inner6, { render, size: 50}),
	optionCallback('inner', 'inner6', Inner7, { render, "transform": { "tl": 0, "tr": 90, "bl": 270, "br": 180 }}),
	optionCallback('inner', 'inner7', Inner8, { render}),
	optionCallback('inner', 'inner8', Inner9, { render}),
	optionCallback('inner', 'inner9', Inner10, { render}),
	optionCallback('inner', 'inner10', Inner11, { render, size: 50}),
	optionCallback('inner', 'inner11', Inner12, { render }),
	optionCallback('inner', 'inner12', Inner13, { render, "transform": { "tl": 270, "tr": 0, "bl": 180, "br": 90 }}),
	optionCallback('inner', 'inner13', Inner14, { render, "transform": { "tl": 0, "tr": 270, "bl": 90, "br": 180 }}),
	optionCallback('inner', 'inner14', Inner15, { render, "transform": { "tl": 0, "tr": 90, "bl": 270, "br": 180 }}),
	optionCallback('inner', 'inner15', Inner16, { render }),
	optionCallback('inner', 'inner16', Inner17, { render, "transform": { "tl": 0, "tr": 90, "bl": 270, "br": 180 }}),
	optionCallback('inner', 'inner17', Inner18, { render }),
	optionCallback('inner', 'inner18', Inner19, { render }),
	optionCallback('inner', 'inner19', Inner20, { render }),
	optionCallback('inner', 'inner20', Inner21, { render, "transform": { "tl": 0, "tr": 90, "bl": 270, "br": 180 }}),
	optionCallback('inner', 'inner21', Inner22, { render }),
	optionCallback('inner', 'inner22', Inner23, { render }),
	optionCallback('inner', 'inner23', Inner24, { render }),
	optionCallback('inner', 'inner24', Inner25, { render }),
	optionCallback('inner', 'inner25', Inner26, { render, "transform": { "tl": 0, "tr": 90, "bl": 270, "br": 180 }}),
	optionCallback('inner', 'inner26', Inner27, { render, "transform": { "tl": 0, "tr": 90, "bl": 270, "br": 180 }}),
	optionCallback('inner', 'inner27', Inner28, { render }),
	optionCallback('inner', 'inner28', Inner29, { render }),
	optionCallback('inner', 'default', Inner1) // default phải luôn ở cuối
)